import { bpsToPercent } from "@faire/deprecated-retailer-visitor-shared/lib/bpsToDecimalAndPercent";
import { useSettingHolidaySpendChallengeCreditBps } from "@faire/deprecated-retailer-visitor-shared/settings/useSettingHolidaySpendChallengeCreditBps";
import { useRetailer } from "@faire/marketplace-lib/stores/retailer/useRetailer";
import { useQuery as useGrowWithFaireQuery } from "@faire/web-api--source/endpoints/www/api/grow-with-faire/retailerToken/get-hooks";
import { MoneyMath } from "@faire/web/common/MoneyMath";

import { useShouldAdvertiseHolidaySpendChallenge } from "./useShouldAdvertiseHolidaySpendChallenge";

export const useGrowWithFaireDetails = () => {
  const { retailerToken } = useRetailer();
  const { isOfferActive } = useShouldAdvertiseHolidaySpendChallenge();

  const {
    data: growWithFaireData,
    isLoading,
    isError,
  } = useGrowWithFaireQuery(retailerToken ?? "", {
    enabled: !!retailerToken && isOfferActive,
  });

  const creditPercentage = bpsToPercent(
    useSettingHolidaySpendChallengeCreditBps()
  );

  const targetSpend = growWithFaireData?.target_spend;
  const currentSpend = growWithFaireData?.current_spend;

  const possibleCredit = targetSpend
    ? MoneyMath.multiply(targetSpend, 0.05)
    : undefined;

  return {
    isLoading,
    isError,
    possibleCredit,
    creditPercentage,
    isEnrolled: growWithFaireData?.enrolled,
    targetSpend,
    currentSpend,
    growWithFaireData,
  };
};
